export default __webpack_public_path__ + "static/media/UCRedesignTVFix.f4507a4c.jpg";